import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ShareStatus } from "@cd/core";
import { api } from "../../lib/api";

/** Accept, set aside, or (pending) take a shared dashboard back out of the sidebar. */
export function useShareResponse() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: ShareStatus }) => api.respondToShare(id, status),
    onSuccess: (_, { id }) => {
      void qc.invalidateQueries({ queryKey: ["dashboards"] });
      void qc.invalidateQueries({ queryKey: ["dashboard", id] });
    },
  });
}
